<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .pull-right.m-t-sm
            button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                :disabled="onLoading('save-supplier')",
                @click="cancel",
            ) Cancel

            button.md-btn.md-raised.m-b-sm.w-xs.green(
                :disabled="onLoading('save-supplier')",
                @click="submit",
            )
                v-loading(loader="save-supplier") Create

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Supplier
                li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Supplier
            .box-divider.m-a-0
            .box-body
                include supplier-form
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import countries from '@js/data/countries.json';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    computed: {
        ...mapGetters('supplier', ['supplier']),
        countries: () => countries,
        country: {
            get() {
                return { name: this.supplier.country };
            },
            set(country) {
                const value = country === null ? null : country.name;
                this.setSupplierAttr({ key: 'country', value });
            },
        },
    },

    created() {
        this.setSupplierAttr({ key: 'id', value: null });
        this.setSupplierAttr({ key: 'name', value: null });
        this.setSupplierAttr({ key: 'address', value: null });
        this.setSupplierAttr({ key: 'postal_code', value: null });
        this.setSupplierAttr({ key: 'city', value: null });
        this.setSupplierAttr({ key: 'country', value: null });
        this.setSupplierAttr({ key: 'region', value: null });
        this.setSupplierAttr({ key: 'contact_name', value: null });
        this.setSupplierAttr({ key: 'contact_no', value: null });
        this.setSupplierAttr({ key: 'contact_email', value: null });
        this.setSupplierAttr({ key: 'contact_fax', value: null });

        this.errors.clear();
    },

    methods: {
        ...mapActions('supplier', ['setSupplierAttr', 'createSupplier']),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            if (!(await this.$validator.validate())) return;

            try {
                const { data } = await this.createSupplier();
                this.swal({ text: 'Supplier has successfully created' });
                this.$router.push('/');
            } catch (e) {
                this.swalError({ text: e });
                throw e;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/supplier/supplier-create.vue